import { useCallback, useState } from 'react';

export type MeshEdgesMode = 'none' | 'edges' | 'wireframe';

export const MESH_EDGES_MODES: MeshEdgesMode[] = ['none', 'edges', 'wireframe'];

function useModelViewerMeshEdges() {
  const [meshEdgesMode, setMeshEdgesMode] = useState<MeshEdgesMode>('none');

  const cycleMeshEdgesMode = useCallback(() => {
    setMeshEdgesMode(
      (prev) =>
        MESH_EDGES_MODES[
          (MESH_EDGES_MODES.indexOf(prev) + 1) % MESH_EDGES_MODES.length
        ]
    );
  }, []);

  return { meshEdgesMode, cycleMeshEdgesMode, setMeshEdgesMode };
}

export default useModelViewerMeshEdges;
